import { render, staticRenderFns } from "./TaskEditor.vue?vue&type=template&id=9938160a&scoped=true&"
import script from "./TaskEditor.vue?vue&type=script&lang=js&"
export * from "./TaskEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9938160a",
  null
  
)

export default component.exports